import { type Url, urlBuilder } from "@42.nl/react-url";
import { type QueryParams } from "../filters/search.hook";

export const GROUP_APP_URL = "/groups";

export function toGroupsApp(queryParams?: Partial<QueryParams>): Url {
  return urlBuilder({ url: GROUP_APP_URL, queryParams });
}
